// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jz-0";
export var fileCarousel = "_jz-2";
export var removeFileButton = "_jz-1";